import _ from 'underscore';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { getWaterfallItemStyles } from '../../../styles/waterfall-item-styles';

const WaterfallItem = ({
  text,
  isSelected,
  classes,
}) => {
  const itemClasses = classNames('waterfall-list-item', classes.item);
  const selectMarkClasses = classNames(
    'waterfall-list-item-mark',
    isSelected
      ? [classes.visibleSelectMark, 'item-visible']
      : [classes.hiddenSelectMark, 'item-hidden']
  );

  return (
    <div className={itemClasses}>
      <div className={selectMarkClasses}>
        <Glyphicon
          glyph="ba-CheckMark"
        />
      </div>
      <span className={classes.text}>
        {text}
      </span>
    </div>
  );
};

WaterfallItem.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getWaterfallItemStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  text: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export const StyledWaterfallItem = withDefaultStyles(WaterfallItem, getWaterfallItemStyles);
